export default __webpack_public_path__ + "static/media/Account_Hover.3d96c16b.png";